import ReturnMessage from "../shared/ReturnMessage";
import Button from "../ui/Button";
import LoadingOverlay from "../shared/LoadingOverlay";
import usePost from "../../hooks/usePost";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalFormWrapper from "../shared/ModalFormWrapper";
import tick from "../../assets/icons/tick-big.svg";
import Checkbox from "../ui/Checkbox";

const PortalProceedContractModal = ({ closeModal, closedBy, dealId, dealNumPets }) => {
    // State
    const [saleHoldPayment, setSaleHoldPayment] = useState(false);
    const [numPets, setNumPets] = useState(dealNumPets);
    const [, setValidateReset] = useState(false);
    const [resetSuccess, setResetSuccess] = useState(false);

    // Hooks
    const { sending: loading, returnMessage } = usePost();
    const { sending, returnData: resetData, returnMessage: resetClosedMessage, postData: postClosed } = usePost();

    // Use effect
    useEffect(() => {
        if (resetData) {
            setResetSuccess(true);
        }
    }, [resetData]);

    // Submit
    const submitHandler = (e) => {
        e.preventDefault();
        setValidateReset(true);
        setResetSuccess(false);

        // Set data
        let formData = {
            saleHoldPayment: saleHoldPayment,
            numPets: numPets,
            dealId: dealId,
        };

        // Post
        postClosed(formData, "/api/portal/setDealContractSent", 1000);
    };

    return (
        <ModalFormWrapper title="Move to Contract Sent">
            <ReturnMessage returnMessage={resetClosedMessage} />

            {loading || sending ? (
                <LoadingOverlay />
            ) : returnMessage.error ? (
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__success">
                            <div className="login-form__body__title">Could not progress deal</div>
                            <br />
                            <br />
                            <div className="login-form__body__submit-container">
                                <Link to="/portal">
                                    <Button onClick={closeModal} disabled={sending} classNames={["button--full"]}>
                                        Return
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            ) : resetSuccess ? (
                <div className="login-form">
                    <div className="login-form__success">
                        <img className="login-form__success__tick" src={tick} alt="" />
                        <div className="login-form__success__message">
                            The deal has been moved to Contract Sent successfully
                        </div>
                        <Button onClick={closeModal}>Return</Button>
                    </div>
                </div>
            ) : (
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__body__title">You are setting this deal to "Contract Sent"</div>
                        <div className="login-form__body__intro">
                            Please check the details below.
                            <br />
                            <strong>PLEASE NOTE THIS WILL CONFIRM THE SELECTED FLIGHT WITH AVINODE.</strong>
                        </div>

                        <form onSubmit={submitHandler}>
                            <label>Num Pets:</label>
                            <fieldset class="fieldset fieldset--margin-bottom">
                                <div class="text-input text-input--margin-bottom">
                                    <input
                                        type="text"
                                        autocomplete="on"
                                        class="text-input__input"
                                        defaultValue={numPets ?? 0}
                                        onChange={(e) => setNumPets(parseInt(e.target.value))}
                                    />
                                    <label class="label label--minimised">Num pets</label>
                                </div>
                            </fieldset>
                            <Checkbox
                                defaultValue={saleHoldPayment}
                                classNames={["checkbox--aircraft-compare"]}
                                tickDark
                                value={(value) => setSaleHoldPayment(value)}
                            >
                                Sale HOLD payment?
                            </Checkbox>

                            <div className="login-form__body__submit-container">
                                <Button disabled={sending} classNames={["button--full"]}>
                                    Save
                                </Button>
                            </div>
                        </form>

                        {sending && <LoadingOverlay />}
                    </div>
                </div>
            )}
        </ModalFormWrapper>
    );
};

export default PortalProceedContractModal;
